import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { colors } from '@offerzen/pinata-shame'
import CloseIcon from '@offerzen/zenicon/CloseIcon'
import NotVisibleEyeIcon from '@offerzen/zenicon/NotVisibleEyeIcon'
import VisibleEyeIcon from '@offerzen/zenicon/VisibleEyeIcon'

import AccessibleIcon from '../AccessibleIcon'

import styles from './styles'

class MobileNavVisibilityBadge extends Component {
  static propTypes = {
    currentState: PropTypes.string,
  }

  state = {
    open: false,
  }

  render() {
    const { currentState, trackVisibilityStatus } = this.props

    return (
      <Choose>
        <When condition={currentState === 'live'}>
          <If condition={this.state.open}>
            <div className={styles.container}>
              <div className={styles.visibility}>
                <strong>
                  You are
                  <span className={styles.visibleText}>visible</span>
                  to companies.
                </strong>
                <button
                  className={styles.badgeClose}
                  aria-label="Close visibility notification"
                  onClick={() => {
                    this.setState({ open: false })
                    trackVisibilityStatus('close explainer')
                  }}
                  type="button">
                  <AccessibleIcon icon={CloseIcon} size={20} color={colors.white} />
                </button>
              </div>
              <div className={styles.paragraph}>
                Companies can view your profile and reach out with job opportunities. Try respond to interview requests within 48 hours as
                companies might withdraw them.
              </div>
            </div>
          </If>
          <button
            className={styles.badgeButton}
            aria-label="Visible badge"
            onClick={() => {
              trackVisibilityStatus(this.state.open ? 'close explainer' : 'open explainer')
              this.setState({ open: !this.state.open })
            }}
            type="button">
            <AccessibleIcon icon={VisibleEyeIcon} size={18} color={colors.cornflowerBlue} />
          </button>
        </When>
        <Otherwise>
          <If condition={this.state.open}>
            <div className={styles.container}>
              <div className={styles.visibility}>
                <strong>
                  You are
                  <span className={styles.notVisibleText}>not visible</span>
                  to companies.
                </strong>
                <button
                  aria-label="Close visibility notification"
                  className={styles.badgeClose}
                  onClick={() => this.setState({ open: false })}
                  type="button">
                  <AccessibleIcon icon={CloseIcon} size={20} color={colors.white} />
                </button>
              </div>
              <div className={styles.paragraph}>
                Companies are not able to view your profile. Keep your profile up to date to avoid having to do time consuming updates when
                you are ready to start looking for a new job.
              </div>
            </div>
          </If>
          <button
            className={styles.badgeButton}
            aria-label="Not visible badge"
            onClick={() => this.setState({ open: !this.state.open })}
            type="button">
            <AccessibleIcon icon={NotVisibleEyeIcon} size={18} color={colors.froly} />
          </button>
        </Otherwise>
      </Choose>
    )
  }
}

export default MobileNavVisibilityBadge
